import { useEffect, useState } from "react";
import { Checkbox, ComboBox, DatePicker, IColumn, IComboBoxOption, Icon, PrimaryButton, Spinner, TooltipHost } from "@fluentui/react";
import CustomModal, { ModalConfirm } from "./CustomModal";
import CustomTable from "./CustomTable";
import { spanishDatePickerStrings } from "../collaboratorCreateView";
import { DateCustom } from "../../../../lib/DateCustom";
import { IUpdateInformacionGeneral } from "./InformacionGeneral";
import { useForm } from "react-hook-form";
import formatearFecha from "../../../../common/formatDate";
import { convertStringToDateProyectoEnalce } from "../../../../common/custom-hooks/TodayDate";
import { IListtransformUpdate, IstructuraUseform } from "./interface";
import Environment from "../../../../lib/Environment";
import { IorganizationLevels } from "../../../../system/AuthenticationSystem";
import { t } from "i18next";


interface IvalueNodeGe extends IorganizationLevels {
  filterValuenode: IComboBoxOption[];
  valuenode: IComboBoxOption[];
  value: string;
  newValue: IComboBoxOption;
  nivel: string;
}


function EstructuraOrganizacionalNEW({ system, datosColaborador, selecusuariosG ,onSaveCollaborator,setCanEdit}: IUpdateInformacionGeneral) {
  const valueEdingManagement = new Environment().EditingManagement() || "1";
  const [activeModal, setActiveModal] = useState<boolean>(false);
  const [eliminar, setEliminar] = useState<boolean>(false);
  const [desactivar, setDesactivar] = useState<boolean>(false);
  const [modificarCrear, setModificarCrear] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingEstruc, setLoadingEstruc] = useState<boolean>(false);

  const [valueTem, setValueTem] = useState<any>(undefined);
  const [item, setItem] = useState<any[]>([]);

  const [cargo, setCargo] = useState<IListtransformUpdate[]>([]);
  const [cargofilter, setCargofilter] = useState<IListtransformUpdate[]>([]);
  const [newcargo, setNewcargo] = useState<IListtransformUpdate>({ key: "9999", text: "" });

  const [valueCargo, setValueCargo] = useState<string | undefined>("");
  const [valueDateDesde, setValueDateDesde] = useState<string | undefined>(undefined);
  const [valueDateHasta, setValueDateHasta] = useState<string | undefined>(undefined);

  const [minDateVigencia, setMinDateVigencia] = useState<Date | undefined>(undefined);
  const [organizationLev, setOrganizationLev] = useState<IvalueNodeGe[]>([]);

  const { register, setValue, formState: { errors }, watch, handleSubmit, reset, clearErrors } = useForm<IstructuraUseform>();

  const [isChangeProfile, setIsChangeprofile] = useState<boolean>(false);
  const [validate, setValidate] = useState("");


  const columns: IColumn[] = [
    {
      key: 'column7', name: t('Activo'), fieldName: 'Activo', minWidth: 45, isResizable: true,
      onRender: (item) => (<div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Checkbox disabled={datosColaborador ? !datosColaborador.col_activo : true} key={"001"} checked={item.Activo === "1" ? true : item.Activo === "0" ? false : undefined} onChange={() => {
          setValueTem(item)
          setDesactivar(!desactivar)
          setModificarCrear(true)
          cleanDateTotal()
        }} />
      </div>)
    },
    {
      key: 'column8', name: t('Eliminar'), fieldName: 'Eliminar', minWidth: 60, isResizable: true,
      onRender: (value) => (<div style={{ display: "flex", alignItems: "center", justifyContent: "center", color: "red", cursor: "pointer" }}>
        {item.length === 1 || (datosColaborador ? !datosColaborador.col_activo : true) ? <Icon iconName='Delete' style={{ fontSize: "20px", color: "black" }} /> : <Icon style={{ fontSize: "20px" }} iconName='Delete' onClick={() => {
          setValueTem(value)
          setEliminar(!eliminar)
          setModificarCrear(true)
          cleanDateTotal()
        }} />}</div>
      )
    },
    {
      key: 'column9', name: t('Modificar'), fieldName: 'Modificar', minWidth: 65, isResizable: true,
      onRender: (item) => (<div style={{ display: "flex", alignItems: "center", justifyContent: "center", color: "#0078D4", cursor: "pointer" }}>
        {(datosColaborador ? datosColaborador.col_activo : true) ? <Icon style={{ fontSize: "20px" }} iconName='SingleColumnEdit' onClick={() => {
          cleanDateTotal();
          setLoading(false);
          SetDataModificar(item)
          setModificarCrear(false);
          setTimeout(() => {
            setLoading(true);
          }, 888)
        }} /> :
          <Icon style={{ fontSize: "20px", color: "black" }} iconName='SingleColumnEdit' />
        }
      </div>
      )
    },
    { key: 'column5', name: t('Desde'), fieldName: 'Desde', minWidth: 80, isResizable: true },
    { key: 'column6', name: t('Hasta'), fieldName: 'Hasta', minWidth: 80, isResizable: true },
    { key: 'column4', name: t('Cargo'), fieldName: 'Cargo', minWidth: 100, isResizable: true },
    ...organizationLev.map(({ nio_nombre, nio_id }) => ({ key: nio_id, name: t(nio_nombre), fieldName: nio_nombre, minWidth: 100, isResizable: true })) as any
  ]

  const cleanDateTotal = () => {
    setOrganizationLev(cleantnodes());
    setValueCargo(undefined);
    setValueDateDesde(undefined);
    setValueDateHasta(undefined);
    setValue("cargo", undefined);
    setValue("carcol_fecha_desde", '');
    setValue("carcol_fecha_hasta", '');
  }

  const cargoList = async () => {
    if (!system) return;
    try {
      const response = await system.listCargo();
      const directions = response.map((item) => {
        const obejts = {
          key: item.cargo_id,
          text: item.cargo_nombre,
        }
        return obejts
      });
      setCargo([...directions]);
      setCargofilter([...directions]);
    } catch (error) {
      console.log(error)
    }
  }

  const onInputValueChangeCargo = (text: string) => {
    setNewcargo({ ...newcargo, text });
    let filtrado = cargo.filter(c => c.text.toLowerCase().includes(text.toLowerCase()));
    setCargofilter(filtrado);
  }

  const onChangeCargoo = (event, option) => {
    let data = option;
    if (option === undefined && newcargo.text !== "") {
      data = newcargo;
    }
    setValue("cargo", data);
    setValueCargo(data?.text)
  }

  const handlerVigencia = (date: Date | null | undefined) => {
    setValueDateDesde(date ? formatearFecha(date) : undefined)
    setValue("carcol_fecha_desde", date ? formatearFecha(date) : '');
  }

  const handlerFechaFin = (date: Date | null | undefined) => {
    setValueDateHasta(date ? formatearFecha(date) : undefined)
    setValue("carcol_fecha_hasta", date ? formatearFecha(date) : '');
  }

  const SetDataModificar = (item) => {

    const setValueMod = organizationLev.map((value, index) => {
      if (item[value.nio_nombre]) {

        setValue(`Estructura Organizacional.${index}.${value.nio_nombre}`, { key: index, text: item[value.nio_nombre] });
        return {
          ...value,
          value: item[value.nio_nombre]
        }
      } else {
        setValue(`Estructura Organizacional.${index}.${value.nio_nombre}`, undefined);
        return {
          ...value,
          value: ''
        }
      }
    })
    setValue("cargo", { key: item.Cargo, text: item.Cargo });
    setValue("carcol_fecha_desde", item.Desde);
    setValue("carcol_fecha_hasta", item.Hasta);
    setValue("carcol_id", item.carcol_id);
    setValue("activo", item.Activo);
    setValueCargo(item.Cargo);
    setValueDateDesde(item.Desde);
    setValueDateHasta(item.Hasta);
    setOrganizationLev(setValueMod);
  }

  const dataTableItem = async () => {
    if (!datosColaborador?.cargoColaborador.carcol_colid) return;
    const result = await system?.ListEstructuraOrganizacional(datosColaborador?.cargoColaborador.carcol_colid);
    if (result?.length === 0) return;

    const mapResult = result?.map(i => {
      const organigrama = i.nodo_organigrama.reduce((acc, item) => {
        acc[item.nivel_nombre] = item.nor_nombre;
        return acc;
      }, {} as { [key: string]: string });

      return {
        Desde: i.carcol_fecha_desde,
        Hasta: i.carcol_fecha_hasta,
        Activo: i.carcol_activo,
        carcol_id: i.carcol_id,
        Cargo: i.cargo.cargo_nombre,
        ...organigrama
      }
    })
    setItem(mapResult as any);
  }

  const delteItem = async (action: string) => {
    if (!valueTem) return;
    if (action === "onConfirm") {
      setModificarCrear(true);
      const data = item?.filter(item => item.carcol_id !== valueTem?.carcol_id);
      setItem(data);
      await system?.DeleteEstructuraOrganizacional(valueTem?.carcol_id);
      setValueTem(undefined);
      dataTableItem();
    } else if (action === "onclose") {
      setValueTem(undefined);
    }
    setEliminar(!eliminar);
  }

  const Update = async (valor: string) => {

    if (!valueTem) return;
    if (valor === "onConfirm") {

      const filterItems = item.filter((i) => i.Activo === "1");

      const onOrOff = {
        activo: valueTem.Activo === '1' ? '0' : valueTem.Activo ? '1' : '0',
        carcol_id: valueTem.carcol_id
      }

      if (onOrOff.activo === '0' && filterItems.length === 1 ) {
        setValidate("*Accion no permitida, se debe tener por lo menos 2 registros activos.");
        setValueTem(undefined);
      } else {
        await system?.UpdateEstructuraOranizacional(onOrOff as any);
        setValueTem(undefined);
        dataTableItem();
      }

    } else if (valor === "onclose") {
      setValueTem(undefined);
    }
    setDesactivar(!desactivar)
  }

  const onsubmit = handleSubmit(async (data) => {
    setLoading(false);
    if (modificarCrear) {
      console.log(data)
      await system?.CreateEstructuraOranizacional(data);

    cleanDateTotal();
     dataTableItem();
    } else {

      await system?.UpdateEstructuraOranizacional(data);

      dataTableItem();
      cleanDateTotal();
      if (item.length) {

        setModificarCrear(true);
      }
    }
    setTimeout(() => {
      setLoading(true);
    }, 888)
  });

  const cleantnodes = (nio_id?: string) => {

    let deleteValueNode: IvalueNodeGe[] = [];
    if (nio_id) {
      const selectedLevelNumber = parseInt(nio_id, 10);
      deleteValueNode = organizationLev.map((item, index) => {
        const itemLevel = parseInt(item.nio_id, 10);
        if (itemLevel > selectedLevelNumber) {
          setValue(`Estructura Organizacional.${index}.${item.nio_nombre}`, undefined);
          return {
            ...item,
            newValue: { key: "9999", text: "" },
            filterValuenode: [],
            valuenode: [],
            value: ''
          }
        };
        return item;
      })
    } else {
      deleteValueNode = organizationLev.map((item, index) => {
        setValue(`Estructura Organizacional.${index}.${item.nio_nombre}`, undefined);
        if (index === 0) {
          return {
            ...item,
            newValue: { key: "9999", text: "" },
            value: ''
          }
        }
        return {
          ...item,
          newValue: { key: "9999", text: "" },
          filterValuenode: [],
          valuenode: [],
          value: ''
        }
      })
    }

    return (deleteValueNode);

  }

  const OnchangeValueNodeLevFilter = (text: string, nio_id: string, newValue: IComboBoxOption, nio_nombre: string, nivel: string) => {   
    setOrganizationLev(organizationLev.map((i) => {
      if (i.nio_id === nio_id) {
        return {
          ...i,
          newValue: { ...newValue, text: text.trimStart() }, // Evitar los espacios en blanco al inicio cuando el usuario escriba
          filterValuenode: i.valuenode.filter(d => d.text.trimStart().toLowerCase().includes(text.trimStart().toLowerCase())) // Evitar los espacios en blanco al inicio cuando el usuario escriba
        }
      }
      return i;
    }));
  }

  const OnchangeValueNodeLev = async (option: IComboBoxOption | undefined, nio_id: string, newValue: IComboBoxOption, nio_nombre: string, nivel: string, index: number) => {
    let data: IComboBoxOption | undefined = option;
    if (option === undefined && newValue.text !== "") {
      data = newValue
    }
    setValue(`Estructura Organizacional.${index}.${nio_nombre}`, data);
    let setValueSelect = cleantnodes(nio_id);
    setValueSelect = setValueSelect.map((item) => {
      if (nio_id === item.nio_id) {
        return {
          ...item,
          value: data?.text || ''
        }
      };
      return item;
    })

    if (option !== undefined) {
      setLoadingEstruc(true);
      const optionParcedata = (option.key) as string;
      const response = await system!.getselcts(nivel, optionParcedata);
      const directions: IComboBoxOption[] = response.map((item) => {
        return {
          key: item.nor_id,
          text: item.nor_nombre,
          nor_nivel: item.nor_nivel,
          nor_padre: item.nor_padre
        }
      });

      setValueSelect = setValueSelect.map((item) => {
        if (nivel === item.nio_id) {
          return {
            ...item,
            valuenode: directions || [],
            filterValuenode: directions || []
          }
        };
        return item;
      });
    }
    setOrganizationLev(setValueSelect);
    setLoadingEstruc(false)
  };

  const getNextLevel = (levels: IorganizationLevels[], currentLevelId: string) => {
    const current = Number(currentLevelId);
    const sortedLevels = levels.slice().sort((a, b) => Number(a.nio_id) - Number(b.nio_id));
    return sortedLevels.find(level => Number(level.nio_id) > current);
  };

  const getOrganizationLevels = async () => {
    setLoading(false);
    dataTableItem()
    const response = await system?.getselcts();
    const levels = await system?.getOrganizationLevels();
    const parcedata = response?.map((item) => ({ key: item.nor_id, text: item.nor_nombre, nor_nivel: item.nor_nivel, nor_padre: item.nor_padre }));

    if (!levels) return;
    const resultnodo = levels.map(({ nio_id, nio_nombre, nio_nombre_tec }, index) => {

      /* 
        Si el id es 1 del nivel entonces significa que es el nivel padre requerido
        Punto de mejora: Se recomienda colocar una columa en la tabla de niveles que diferencie el primer nivel con los demas
       */
      register(`Estructura Organizacional.${index}.${nio_nombre}` , { required: nio_id === '1' });

      const nodoEncontrado = getNextLevel(levels, nio_id);
      return {
        nio_id,
        nio_nombre,
        nio_nombre_tec,
        valuenode: nio_id === '1' ? (parcedata || []) : [],
        filterValuenode: nio_id === '1' ? (parcedata || []) : [],
        value: "",
        newValue: { key: "9999", text: "" },
        nivel: nodoEncontrado ? nodoEncontrado.nio_id : ''
      };
    });
    register("cargo", { required: true });
    register("carcol_fecha_desde", { required: true });
    register("carcol_fecha_hasta");
    register("carcol_id");
    register("activo");
    register("carcol_id");
    setOrganizationLev(resultnodo);
    setLoading(true);
  }

  const HandlerTypeUserModif = ()=>{
    if(selecusuariosG?.key !== datosColaborador?.us_perid){
      setIsChangeprofile(true);
      return;
    }
    setActiveModal(!activeModal);
  }

  const HandlerChangeProfileUser = async ()=>{
        setIsChangeprofile(false);
        await onSaveCollaborator();
        setTimeout(()=>{
          setActiveModal(true)
         },5000);
  }

  useEffect(() => {
    if (item) {
      if (modificarCrear === true) {
        let convertStringToDat = item[0]?.Hasta;
        if (convertStringToDat) {
          setMinDateVigencia(convertStringToDateProyectoEnalce(convertStringToDat));
        }
      } else {
        clearErrors()
        setMinDateVigencia(undefined);
      }
    }

    register("carcol_fecha_desde", {
      required: true, validate: (e) => {
        if (item?.length === 0) return true;
        if (modificarCrear === true) {
          if (item[0].Hasta === null) {
            return "error";
          }
          return true
        } else {
          return true;
        }
      }
    });

  }, [modificarCrear, activeModal, item]);

  useEffect(() => {

    if (activeModal === true && datosColaborador?.cargoColaborador?.carcol_colid) {
      setModificarCrear(true);
      cargoList();
      getOrganizationLevels()
      setValue("carcol_colid", datosColaborador?.cargoColaborador?.carcol_colid || '');
      setValue("activo", '1');
    }

    return () => {
      clearErrors()
      cleanDateTotal()
    };
  }, [activeModal]);


  if (!datosColaborador?.col_activo) {
    return (
      <div className="form_informacion_general">
        <p className="titulo_form_create"> <Icon iconName="Org" style={{ fontSize: "25px" }} /> {t('Estructura Organizacional')} </p>
        <PrimaryButton style={{ marginLeft: "15px" }} onClick={() => setActiveModal(!activeModal)}> {t('Organización')} </PrimaryButton>
        {activeModal &&
          <CustomModal hidden={activeModal} onDismiss={() => setActiveModal(!activeModal)} key="Estructura Oraganizacional"
            title={t('Detalles Estructura Organizacional')} minWidth={700} minHeight={330} >
            <div style={{ maxHeight: '220px', display: 'block', overflowY: 'auto', }} >
              <CustomTable items={item} columns={columns} />
            </div>
          </CustomModal>
        }
      </div>
    )
  }


  console.log("items", item);
  

  return (
    <div className="form_informacion_general">
      <ModalConfirm key={"profileUser"} message={t('¿Deseas guardar los cambios en la informacion general del usuario antes de continuar?')}
        isOpen={isChangeProfile} onClose={() => setIsChangeprofile(false)} onConfirm={ () => HandlerChangeProfileUser()}  
      />
      <p className="titulo_form_create"> <Icon iconName="Org" style={{ fontSize: "25px" }} /> {t('Estructura Organizacional')} </p>
      <PrimaryButton style={{ marginLeft: "15px" }} onClick={() => HandlerTypeUserModif()}> {t('Organización')} </PrimaryButton>
      {activeModal &&
        <CustomModal hidden={activeModal} onDismiss={() => setActiveModal(!activeModal)} key="Estructura Oraganizacional"
          title={t('Detalles Estructura Organizacional')} minWidth={700} minHeight={650} >
          <div style={{ maxHeight: '220px', display: 'block', overflowY: 'auto', }} >
            {validate ? <span style={{ color:"red", fontWeight:"600"}}>{validate}</span> : null}
            <CustomTable items={item} columns={columns} />
          </div>
          <hr />
          <div>
            {loading ?
              <form key={'formtUpdate'} className="cuerpo_izquierdo_form" onSubmit={onsubmit}>
                <div style={{ position: 'relative' }}>
                  {
                    organizationLev.map(({ nio_id, nio_nombre, nio_nombre_tec, filterValuenode, valuenode, value, newValue, nivel }, index) => {

                      return (
                        <>
                          <ComboBox
                            key={nio_id}
                            allowFreeInput={true}
                            className="label_reusable"
                            placeholder={t("Seleccione la ") + t(nio_nombre)}
                            label={t(nio_nombre)}
                            options={filterValuenode}
                            text={value || undefined}
                            onChange={(_, option) => OnchangeValueNodeLev(option, nio_id, newValue, nio_nombre, nivel, index)}
                            onInputValueChange={(text) => OnchangeValueNodeLevFilter(text, nio_id, newValue, nio_nombre, nivel)}
                            styles={{ root: { width: "302px" } }}
                            allowFreeform={valueEdingManagement === "1" ? true : false}
                            selectedKey={nio_id}
                          />
                          {errors["Estructura Organizacional"]?.[index]?.[nio_nombre] && <span className="error_stilos_Organizacional">{t(nio_nombre)} {t('no puede ser vacío.')}</span>}
                        </>
                      )
                    })
                  }
                  {loadingEstruc && <div className='spinner-overlay-create-col'><Spinner /></div>}
                </div>
                <ComboBox
                  className="label_reusable"
                  placeholder={t("Escribir el cargo")}
                  label={t("Cargo")}
                  options={cargofilter}
                  styles={{ root: { width: "170px" } }}
                  onChange={(event, option) => onChangeCargoo(event, option)}
                  onInputValueChange={onInputValueChangeCargo}
                  text={valueCargo}
                  allowFreeform
                />
                {errors.cargo?.type === "required" && <span className="error_TextFile_proyectofijo" >{t('El cargo no puede ser vacío.')}</span>}
                <div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                    <span className="label_reusable">
                      <TooltipHost content={t("Seleccione la fecha de ingreso")}>
                        <DatePicker allowTextInput
                          strings={spanishDatePickerStrings}
                          formatDate={DateCustom.formatDateForDatePicker}
                          placeholder={t("Seleccione la fecha de ingreso")}
                          label={t("Vigencia")}
                          styles={{ root: { width: "170px" } }}
                          minDate={minDateVigencia}
                          onSelectDate={(date) => handlerVigencia(date)}
                          value={valueDateDesde ? convertStringToDateProyectoEnalce(valueDateDesde) : undefined}
                        />
                      </TooltipHost>
                    </span>
                    <p style={{ marginTop: "30px" }}>{t('hasta')}</p>
                    <span style={{ marginTop: "27px" }} >
                      <TooltipHost content={t("Seleccione la fecha de fin")}>
                        <DatePicker allowTextInput
                          strings={spanishDatePickerStrings}
                          formatDate={DateCustom.formatDateForDatePicker}
                          placeholder={t("Seleccione la fecha de fin")}
                          styles={{ root: { width: "170px" } }}
                          minDate={watch("carcol_fecha_desde") ? convertStringToDateProyectoEnalce(watch("carcol_fecha_desde")) : undefined}
                          onSelectDate={(date) => handlerFechaFin(date)}
                          value={valueDateHasta ? convertStringToDateProyectoEnalce(valueDateHasta) : undefined}
                        />
                      </TooltipHost>
                    </span>
                  </div>
                  {errors.carcol_fecha_desde?.type === "validate" && <span className="error_TextFile_proyectofijo" >{t('Primero debes finalizar la estructura organizacional anterior.')}</span>}
                  {errors.carcol_fecha_desde?.type === "required" && <span className="error_TextFile_proyectofijo" >{t('La de vigencia no puede ser vacío.')}</span>}
                </div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  {
                    modificarCrear ? <PrimaryButton width="55" type="submit" >{t('Agregar')}</PrimaryButton> :
                      <div style={{ display: 'flex', gap: "20px" }}>
                        <PrimaryButton type="submit" style={{ marginLeft: "10px", marginTop: "10px" }} >{t('Modificar')}</PrimaryButton>
                        <PrimaryButton style={{ marginTop: "10px" }} onClick={() => {
                          cleanDateTotal();
                          setModificarCrear(true)
                        }}>{t('cancelar')}</PrimaryButton>
                      </div>
                  }
                </div>
              </form> : <div style={{ display: "flex", justifyContent: "center" }}><div className="loader_Proyect"></div></div>}
          </div>
          <ModalConfirm key={"eliminar"} message={t('¿Estás seguro de eliminar esta Estructura Organizacional?')} isOpen={eliminar} onClose={() => delteItem("onclose")} onConfirm={() => delteItem("onConfirm")}
          />
          <ModalConfirm key={"desactivar"} message={t(valueTem?.Activo === "1" ? '¿Estás seguro de desactivar esta Estructura Organizacional?' : '¿Estás seguro de activar esta Estructura Organizacional?')}
            isOpen={desactivar} onClose={() => Update("onclose")} onConfirm={() => Update("onConfirm")} />
        </CustomModal>}
    </div>
  )
}

export default EstructuraOrganizacionalNEW;